import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AutoRefillService {
  private apiUrl = '';

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl;
  }

  getKrollPatientRx(userId: string, pharmacyId: number, krollPatId: number): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + 'api/AutoRefill/GetKrollPatientRx/' + encodeURIComponent(userId) + '/' + pharmacyId + '/' + krollPatId
    );
  }

  getTodoList(userId: string, pharmacyId: number, daysAhead: number, nursingHome: string): Observable<any[]> {
    var q = nursingHome ? '?nursingHome=' + encodeURIComponent(nursingHome) : '';
    return this.http.get<any[]>(
      this.apiUrl + 'api/AutoRefill/GetTodoList/' + encodeURIComponent(userId) + '/' + pharmacyId + '/' + daysAhead + q
    );
  }

  getPatientSchedules(userId: string, pharmacyId: number, facilityId: number, patientId: number): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + 'api/AutoRefill/GetPatientSchedules/' + encodeURIComponent(userId) + '/'
        + pharmacyId + '/' + facilityId + '/' + patientId
    );
  }

  getRefillHistory(userId: string, scheduleId: number): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + 'api/AutoRefill/GetRefillHistory/' + encodeURIComponent(userId) + '/' + scheduleId
    );
  }

  getCycleOptions(userId: string, scheduleId: number): Observable<any[]> {
    return this.http.get<any[]>(
      this.apiUrl + 'api/AutoRefill/GetCycleOptions/' + encodeURIComponent(userId) + '/' + scheduleId
    );
  }

  saveSchedule(userId: string, body: object): Observable<any> {
    return this.http.post(
      this.apiUrl + 'api/AutoRefill/SaveSchedule/' + encodeURIComponent(userId),
      body
    );
  }

  completeRefill(userId: string, body: object): Observable<any> {
    return this.http.post(
      this.apiUrl + 'api/AutoRefill/CompleteRefill/' + encodeURIComponent(userId),
      body
    );
  }

  failRefill(userId: string, body: object): Observable<any> {
    return this.http.post(
      this.apiUrl + 'api/AutoRefill/FailRefill/' + encodeURIComponent(userId),
      body
    );
  }

  deactivateSchedule(userId: string, scheduleId: number): Observable<any> {
    return this.http.post(
      this.apiUrl + 'api/AutoRefill/DeactivateSchedule/' + encodeURIComponent(userId) + '/' + scheduleId,
      {}
    );
  }

  updateSchedule(userId: string, body: object): Observable<any> {
    return this.http.post(
      this.apiUrl + 'api/AutoRefill/UpdateSchedule/' + encodeURIComponent(userId),
      body
    );
  }

}
